// import React, { useState } from 'react';
// import {
//   FaBars,
//   FaUser,
//   FaCalendarAlt,
//   FaPlusCircle,
//   FaSyncAlt,
//   FaSignOutAlt
// } from 'react-icons/fa';
// import logo from '../../assets/image/logo.png';
// import profileimage from '../../assets/image/profileimage.png';
// import './topheader.css';
// import { useNavigate } from 'react-router-dom';

// const Topheader = () => {
//   const firstname = localStorage.getItem("firstname");

//   const [isMenuOpen, setIsMenuOpen] = useState(false);
// const navigate =useNavigate();
//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const Logoutprofile = () =>{
//     localStorage.clear(); 

//     navigate("/")
//   }
//   const packagered = ()=>{
//     navigate("/package")

//   }
//   const booking = ()=>{
//     navigate("/dashbord")

//   }
//   const manage = ()=>{
//     navigate("/reschedule")

//   }

//   return (
//     <>
//       <nav className="navbar navbar-expand-lg navbar-light bgcolorheader">
//         <FaBars className="menu-icon d-lg-none mr-3" onClick={toggleMenu} />
//         <a className="navbar-brand" href="/dashbord">
//           <img src={logo} alt="Logo" className="logoimage" />
//         </a>

//         <div className="collapse navbar-collapse" id="navbarNav">
//           <ul className="navbar-nav ml-auto d-none d-lg-flex align-items-center">
//             <li className="nav-item">
//               <a className="nav-link text-white d-flex align-items-center" href="/reschedule">
//                 <FaCalendarAlt className="mr-2" /> Manage Class
//               </a>
//             </li>
//             <li className="nav-item">
//               <a className="nav-link text-white d-flex align-items-center" href="/dashbord">
//                 <FaPlusCircle className="mr-2" /> New Booking
//               </a>
//             </li>
//             <li className="nav-item">
//               <a className="nav-link text-white d-flex align-items-center" href="/package">
//                 <FaSyncAlt className="mr-2" /> Renew
//               </a>
//             </li>
//             <li className="nav-item">
//               <a className="nav-link text-white d-flex align-items-center" onClick={Logoutprofile}>
//                 <FaSignOutAlt className="mr-2" /> Logout
//               </a>
//             </li>
//             <li className="nav-item">
//               <FaUser className="user-icon text-white" />
//             </li>
//           </ul>
//         </div>
//       </nav>

//       {isMenuOpen && (
//         <>
//           <div className="mobile-menu-overlay" onClick={toggleMenu}></div>
//           <div className="mobile-menu-custom">
//             <div className="mobile-menu-header text-white">
//               <div className="close-btn" onClick={toggleMenu}>&times;</div>

//               <div className="profile-wrapper">
//                 <div className="profile-circle-bg">
//         <a  href="/dashbord">

//                   <img src={profileimage} alt="Profile" className="profile-img-lg" />
//                   </a>
//                 </div>
//               </div>

//               <div className="text ml-1">
//                 <p className="welcome-text mb-1">Welcome</p>
//                 <h5 className="username mb-1">{firstname}</h5>
//               </div>

//               {/* <div className="ml-auto profile-link">
//                 <FaUser className="mr-1" />
//                 <span>My Profile</span>
//               </div> */}
//             </div>

//             <ul className="list-unstyled menu-items text-center mt-4">
//               <li onClick={manage}><FaCalendarAlt className="menu-icon" onClick={manage} /> Manage Class</li>
//               <li onClick={booking}><FaPlusCircle className="menu-icon" onClick={booking} /> New Booking</li>
//               <li onClick={packagered}><FaSyncAlt className="menu-icon" onClick={packagered} /> Renew</li>
//               <li onClick={Logoutprofile}><FaSignOutAlt className="menu-icon" onClick={Logoutprofile} /> Logout</li>
//             </ul>
//           </div>
//         </>
//       )}
//     </>
//   );
// };

// export default Topheader;


import React, { useState } from 'react';
import {
  FaBars, FaUser, FaCalendarAlt, FaPlusCircle, FaSyncAlt, FaSignOutAlt
} from 'react-icons/fa';
import logo from '../../assets/image/logo.png';
import profileimage from '../../assets/image/profileimage.png';
import './topheader.css';
import { useNavigate } from 'react-router-dom';

const Topheader = () => {
  const firstname = localStorage.getItem("firstname");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const logout = () => {
    localStorage.clear();
    navigate('/');
  };

  const navItems = [
    { label: 'Manage Class', icon: <FaCalendarAlt />, path: '/reschedule' },
    { label: 'New Booking', icon: <FaPlusCircle />, path: '/dashbord' },
    { label: 'Renew', icon: <FaSyncAlt />, path: '/package' },
  ];

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bgcolorheader fixed-topheader">
        <FaBars className="menu-icon d-lg-none mr-3" onClick={toggleMenu} />
        <a className="navbar-brand" href="/dashbord">
          <img src={logo} alt="Logo" className="logoimage" />
        </a>

        <div className="collapse navbar-collapse d-none d-lg-block">
          <ul className="navbar-nav ml-auto d-flex align-items-center">
            {navItems.map(({ label, icon, path }, idx) => (
              <li key={idx} className="nav-item">
                <a className="nav-link text-white d-flex align-items-center" href={path}>
                  {icon} <span className="ml-2">{label}</span>
                </a>
              </li>
            ))}
            <li className="nav-item">
              <span className="nav-link text-white d-flex align-items-center" onClick={logout} style={{ cursor: 'pointer' }}>
                <FaSignOutAlt className="mr-2" /> Logout
              </span>
            </li>
            <li className="nav-item">
              <FaUser className="user-icon text-white" />
            </li>
          </ul>
        </div>
      </nav>

      {isMenuOpen && (
        <>
          <div className="mobile-menu-overlay" onClick={toggleMenu}></div>

          <div className="mobile-menu-custom">
            <div className="mobile-menu-header">
              <div className="close-btn" onClick={toggleMenu}>&times;</div>
              <div className="profile-wrapper">
                <a href="/dashbord">
                  <img src={profileimage} alt="Profile" className="profile-img-lg" />
                </a>
              </div>
              <div className="text ml-1">
                <p className="welcome-text mb-1">Welcome</p>
                <h5 className="username mb-1">{firstname}</h5>
              </div>
            </div>
            <ul className="menu-items text-left mt-4">
              {navItems.map(({ label, icon, path }, idx) => (
                <li key={idx} onClick={() => { toggleMenu(); navigate(path); }}>
                  {icon} <span className="ml-2">{label}</span>
                </li>
              ))}
              <li onClick={logout}><FaSignOutAlt /> <span className="ml-2">Logout</span></li>
            </ul>
          </div>
        </>
      )}
    </>
  );
};

export default Topheader;
